{
	"Writing": [
		"k-pop-and-the-sanitization-of-black-culture",
		"hundreds-gather-for-trans-day-of-vengeance",
		"montreal-trans-community-reflects-on-nationwide-bigotry"
	],
	"Photos": [
		"the-phd-trap",
		"heavy-with-desire",
		"pro-palestine-strikes-concordia-two-arrests-campus-closure"
	],
	"mainHighlight": {
		"slug": "pro-palestine-strikes-concordia-two-arrests-campus-closure",
		"imageIndex": 1
	},
	"mainStories": [
		{
			"slug": "azzurri-10-stingers-0-italy-swarms-concordia"
		},
		{
			"slug": "k-pop-and-the-sanitization-of-black-culture"
		},
		{
			"slug": "the-pill-problem"
		}
	],
	"highlightSections": [
		{
			"name": "The Link Newspaper - News",
			"section": "news",
			"count": 12
		},
		{
			"name": "The Link Newspaper - Art",
			"section": "fringe arts",
			"count": 4
		},
		{
			"name": "The Link Newspaper - Sports",
			"section": "sports",
			"count": 8
		}
	]
}